import { FormControl as BriqCommonFormControl } from '@briq/shared'

export const FormError = BriqCommonFormControl.FormError

export const FormControl = BriqCommonFormControl.FormControl
